// extracted by mini-css-extract-plugin
export default {"label":"styles_label__nfOSh"};